import { Icons } from '@/components/Shares/Icons';
import { Avatar, Button, Group, Menu, ScrollArea, Text, rem } from '@mantine/core';
import { useState } from 'react';
import classes from './AccountInfo.module.css';
import { type PhoneNumberType, phones } from './phone';
export const PhoneSelected: React.FC = () => {
  const [code, setCode] = useState<PhoneNumberType>(phones[0]);
  return <Menu shadow="md" position="bottom-start" classNames={classes}>
      <Menu.Target>
        <Button h={40} variant="filled" style={{
        pointerEvents: 'auto'
      }} classNames={{
        section: classes.section,
        root: classes.root
      }} rightSection={<Icons className="icon-pr-line-chevron-down" fontSize={20} color="var(--text-dark)" />}>
          <Group gap={5}>
            <Avatar src={code.icon} size={24} variant="transparent" />
            <Text fz={rem(13)} c="var(--text-dark)" fw={700}>
              {code.areaCode}
            </Text>
          </Group>
        </Button>
      </Menu.Target>

      <Menu.Dropdown style={{
      pointerEvents: 'auto'
    }} w={220}>
        <ScrollArea h={220}>
          {phones.map(item => <Menu.Item key={item.name} leftSection={<Avatar variant="transparent" src={item.icon} size={24} />} onClick={() => setCode(item)}>
              {item.name}
            </Menu.Item>)}
        </ScrollArea>
      </Menu.Dropdown>
    </Menu>;
};